import { create } from 'zustand';
import { AppNode } from '../types';

interface ReferenceNode {
  id: string;
  node: AppNode;
  thumbnailUrl?: string;
}

interface ReferenceState {
  referencedNodes: ReferenceNode[];
  addReference: (node: AppNode) => void;
  removeReference: (id: string) => void;
  clearReferences: () => void;
  setReferences: (nodes: ReferenceNode[]) => void;
  isReferenced: (id: string) => boolean;
}

export const useReferenceStore = create<ReferenceState>((set, get) => ({
  referencedNodes: [],

  addReference: (node) => {
    set((state) => {
      if (state.referencedNodes.some((r) => r.id === node.id)) {
        return state;
      }
      const thumbnailUrl = node.data.image || node.data.videoUri || undefined;
      return {
        referencedNodes: [...state.referencedNodes, { id: node.id, node, thumbnailUrl }],
      };
    });
  },

  removeReference: (id) => {
    set((state) => ({
      referencedNodes: state.referencedNodes.filter((r) => r.id !== id),
    }));
  },

  clearReferences: () => {
    set({ referencedNodes: [] });
  },

  setReferences: (nodes) => {
    set({ referencedNodes: nodes });
  },

  isReferenced: (id) => {
    return get().referencedNodes.some((r) => r.id === id);
  },
}));

if (import.meta.hot) {
  import.meta.hot.accept();
}
